<template>
  <div>
    <v-card class="mx-auto  ">
      <v-col class="pl-0 pr-0 pb-1">
        <v-row class="px-2 py-2">
          <v-col
            cols="12"
            sm="4"
            md="3"
            lg="2"
            xl="2"
            class="  py-0 my-0"
          >
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="startDate"
              transition="scale-transition"
              offset-y
              min-width="auto"
              outlined
              dense
            >
              <template v-slot:activator="{on, attrs}">
                <v-text-field
                  v-model="startDate"
                  label="Tarih"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="startDate"
                no-title
                scrollable
              >
                <v-spacer />
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(startDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            md="3"
            lg="3"
            xl="2"
            class="  py-0 my-0"
          >
            <v-select
              v-model="alarmCodeModel"
              :items="alarmCodeList"
              :label="$t('Alarm Türü')"
              multiple
              outlined
              dense
              :placeholder="$t('Durum')"
            >
              <template v-slot:selection="{item, index}">
                <span
                  v-if="index === 0"
                  style="max-width: 120px"
                  class="d-inline-block text-truncate"
                >{{ item.text
                }}</span>
                <span
                  v-if="index === 1"
                  class="grey--text text-caption"
                >
                  (+{{ alarmCodeModel.length - 1 }})
                </span>
              </template>
            </v-select>
          </v-col>

          <v-col
            cols="12"
            sm="3"
            md="2"
            lg="2"
            xl="1"
            class="  py-0 my-0"
          >
            <v-select
              v-model="alarmStatusModel"
              :items="alarmStatus"
              :label="$t('')"
              multiple
              outlined
              dense
              :placeholder="$t('Durum')"
            >
              <template v-slot:selection="{item, index}">
                <span
                  v-if="index === 0"
                  style="max-width: 120px"
                  class="d-inline-block text-truncate"
                >{{ item.text
                }}</span>
                <span
                  v-if="index === 1"
                  class="grey--text text-caption"
                >
                  (+{{ alarmStatusModel.length - 1 }})
                </span>
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="12"
            sm="3"
            md="2"
            lg="2"
            xl="1"
            class="  py-0 my-0"
          >
            <v-select
              v-model="alarmTypeModel"
              :items="alarmType"
              :label="$t('')"
              multiple
              outlined
              dense
              :placeholder="$t('Tip')"
            >
              <template v-slot:selection="{item, index}">
                <span
                  v-if="index === 0"
                  style="max-width: 120px"
                  class="d-inline-block text-truncate"
                >{{ item.text
                }}</span>
                <span
                  v-if="index === 1"
                  class="grey--text text-caption"
                >(+{{ alarmTypeModel.length - 1 }})
                </span>
              </template>
            </v-select>
          </v-col>

          <v-col
            cols="12"
            sm="4"
            md="3"
            lg="2"
            xl="2"
            class="  py-0 my-0"
          >
            <v-select
              v-model="santralModel"
              :items="santralDataList"
              :label="$t('santral')"
              :placeholder="$t('')"
              multiple
              outlined
              dense
            >
              <template v-slot:selection="{item, index}">
                <span
                  v-if="index === 0"
                  style="max-width: 120px"
                  class="d-inline-block text-truncate"
                >{{ item
                }}</span>
                <span
                  v-if="index === 1"
                  class="grey--text text-caption"
                >
                  (+{{ santralModel.length - 1 }})</span>
              </template>
            </v-select>
          </v-col>

          <v-col
            cols="12"
            sm="4"
            md="3"
            lg="3"
            xl="2"
            class="  py-0 my-0"
          >
            <TextField
              v-model="search"
              :label="$t('Ara')"
              :outlined="true"
              :dense="true"
              :placeholder="$t('Ara')"
            />
          </v-col>

          <v-col
            cols="6"
            sm="2"
            md="2"
            lg="1"
            xl="1"
            class="  py-0 my-0"
          >
            <v-btn
              color="primary"
              @click="setParams"
            >
              Filtrele
            </v-btn>
          </v-col>

          <v-col
            cols="6"
            sm="2"
            md="1"
            lg="1"
            xl="1"
            class="  py-0 my-0"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn
                  fab
                  dark
                  small
                  color="cyan"
                  v-on="on"
                  @click="exportDocument"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>Export to Excel</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>

      <v-col
        cols="12"
        class="fullgridtable pl-0 pr-0 pb-1"
      >
        <Card
          width="100%"
          height="100%"
          :elevation="0"
        >
          <v-data-table
            :id="santralDataTable"
            dense
            :items-per-page.sync="itemsPerPage"
            :server-items-length="itemsLength"
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 30, 40, 50, 100],
              showFirstLastPage: true,
              itemsPerPageText: 'Limit'
            }"
            :options.sync="options"
            :headers="headers"
            :page.sync="currentPage"
            :loading="loading"
            loading-text="Yükleniyor... Lütfen bekleyiniz"
            :items="desserts"
            class=""
          >
            <template v-slot:item.status="{item}">
              <v-chip
                v-if="item.status === 'Active'"
                color="green"
                label
              >
                <span>
                  Aktif
                </span>
              </v-chip>
              <v-chip
                v-else
                label
                color="red"
              >
                Pasif
              </v-chip>
            </template>

            <template v-slot:item.alarm="{item}">
              <v-chip
                color="primary"
                small
                label
                @click="alarmDetailDessertFunc(item)"
              >
                <v-icon left>
                  mdi-open-in-new
                </v-icon>
                {{ item.alarm.length }}
              </v-chip>
            </template>
          </v-data-table>
        </Card>
      </v-col>
    </v-card>

    <Dialog
      v-model="dialog"
      width="1200px"
    >
      <Card
        width="1200px"
        height="100%"
        max-height="700px"
      >
        <v-data-table
          loading-text="Yükleniyor... Lütfen bekleyiniz"
          dense
          :headers="alarmDetailHeader"
          :items="alarmDetailDessert"
          class="elevation-1"
        >
          <template v-slot:item.status="{item}">
            <v-chip
              v-if="item.status === 'Active'"
              color="green"
              label
            >
              Aktif
            </v-chip>
            <v-chip
              v-else
              color="red"
              label
            >
              Pasif
            </v-chip>
          </template>
          <template v-slot:item.severity_text="{item}">
            <span v-html="setSeverityText(item)" />
          </template>

          <template v-slot:top>
            <Toolbar height="40px">
              <span>
                <b> Santral: </b>{{ selectedDevice.santral }} /
                <b> Cihaz: </b> {{ selectedDevice.device }} /
                <b> Alarm: </b> {{ selectedDevice.alarmCode }}
              </span>
              <v-spacer />
              <Button
                :icon="true"
                :elevation="0"
                @click="dialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </Button>
            </Toolbar>
            <v-divider />
          </template>
        </v-data-table>
      </Card>
    </Dialog>
    <ExportDocument :export-document-open="exportDocumentOpen" />
  </div>
</template>
<script>
import moment from 'moment';
import { getDeviceAlarm } from '@/api/Request/Notification';
import helper from '@/api/helper';

export default {
  data: () => ({
    santralModel: [],
    chartData: {},
    startDate: moment().format('YYYY-MM-DD'),
    finishDate: moment()
      .add(1, 'day')
      .format('YYYY-MM-DD'),
    menu: false,
    modal: false,
    menu2: false,
    itemsPerPage: 15,
    itemsLength: 0,
    headers: [],
    desserts: [],
    channelModel: 'STRINGBOX',
    channel: [
      { text: 'String', value: 'STRINGBOX' },
      { text: 'İnverter', value: 'INVERTER' },
    ],
    alarmType: [
      { text: 'Hata', value: 'Error' },
      { text: 'Uyarı', value: 'Warning' },
    ],
    alarmTypeModel: [],
    alarmStatusModel: [],
    alarmStatus: [
      { text: 'Aktif', value: 'Active' },
      { text: 'Pasif', value: 'Passive' },
    ],
    alarmCodeModel: [],
    exportDocumentOpen: {
      open: false,
      tableID: null,
    },
    santralDataTable: '',
    chartText: '',
    newData: 'true',
    search: null,
    currentPage: 1,
    loading: false,
    options: {
      itemsPerPage: 15,
      page: 1,
      sortBy: [],
      sortDesc: [],
    },
    params: {
      condinition: {
        startDate: moment().format('YYYY-MM-DD'),
        finishDate: moment()
          .add(1, 'day')
          .format('YYYY-MM-DD'),
        type: [],
        status: ['Active'],
        santral: [],
      },
    },
    dialog: false,

    alarmDetailHeader: [
      { text: 'Alarm', value: 'text' },
      { text: 'Cihaz', value: 'device' },
      { text: 'Alt Cihaz', value: 'subdevice' },
      { text: 'Alarm Adı', value: 'alarmName' },

      { text: 'Oluşturma', value: 'createTime' },
      { text: 'Pasif', value: 'passivetime' },
      { text: 'Bildirim', value: 'mailSendDate' },
      { text: 'Güncelleme', value: 'updateTime' },
      { text: 'Durum', value: 'status' },
      { text: 'Hata süresi', value: 'lifetime' },
      { text: 'Önem', value: 'severity_text' },
    ],
    alarmDetailDessert: [],
    selectedDevice: {},
    alarmDetailItemsPerPage: 10,
    alarmDetailItemsLength: 0,
    alarmDetailPage: 0,
    searchTimerId: null,
    severity: [],
  }),
  computed: {
    santralDataList() {
      return this.$store.getters.santralDataList;
    },
    alarmCodeList() {
      return this.$store.getters.alarmCodeList;
    },
  },
  watch: {

    search() {
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.getSearchData(this.search);
      }, 1500);
    },

    reportTypeModel() {
      this.setParams();
    },

    options: {
      handler() {
        this.loading = true;
        const {
          sortBy, sortDesc, page, itemsPerPage,
        } = this.options;

        if (sortBy.length > 0) {
          this.params.orderBys = [{ fieldName: sortBy[0], sortType: sortDesc[0] }];
        }
        this.params.skip = (page - 1) * itemsPerPage;
        this.params.limit = itemsPerPage;
        this.setParams();
      },
    },
  },
  created() { },
  mounted() {
    const { severity } = this.$store.getters;
    this.severity = severity;
  },
  methods: {
    setSeverityText(item) {
      let text = item.severity_text;
      this.severity.forEach((element) => {
        if (element.key === item.severity_text) {
          text = element.text;
        }
      });
      return text;
    },

    getSearchData(item) {
      this.params.search = item;
      this.getErrorTable();
    },
    alarmDetailDessertFunc(item) {
      this.dialog = true;
      this.alarmDetailDessert = item.alarm;
      this.selectedDevice = {
        device: item.device,
        alarmCode: item.alarmCode,
        santral: item.santral,
      };
      this.alarmDetailItemsLength = item.alarm.length;
    },
    exportDocument() {
      this.exportDocumentOpen.open = true;
      this.exportDocumentOpen.tableID = this.santralDataTable;
    },
    setParams() {
      this.desserts = [];
      this.itemsLength = 0;
      this.finishDate = this.startDate;
      this.headers = [
        { text: 'Santral', value: 'santral' },
        { text: 'Cihaz', value: 'device' },
        { text: 'Alarm Tarihi', value: 'warningTime' },
        { text: 'Alarm', value: 'text' },
        { text: 'Alarm sayısı', value: 'alarm', sortable: false },
        { text: 'Durum', value: 'status' },

      ];

      this.finishDate = moment(this.startDate)
        .add(1, 'day')
        .format('YYYY-MM-DD');

      this.params.condinition.startDate = this.startDate;
      this.params.condinition.finishDate = this.finishDate;

      if (this.santralModel.length > 0) {
        this.params.condinition.santral = this.santralModel;
      }
      if (this.alarmTypeModel.length > 0) {
        this.params.condinition.type = this.alarmTypeModel;
      }
      if (this.alarmStatusModel.length > 0) {
        this.params.condinition.status = this.alarmStatusModel;
      }

      if (this.alarmCodeModel.length > 0) {
        this.params.condinition.alarmCode = this.alarmCodeModel;
      }

      if (this.farmdata) {
        this.params.prefix = this.farmdata.prefix;
        this.params.companyCode = this.farmdata.companyCode;
      }

      this.getErrorTable();
    },

    getErrorTable() {
      this.loading = true;
      const self = this;
      this.desserts = [];

      getDeviceAlarm(this.params).then((res) => {
        if (res.data.success === 'true') {
          if (helper.resIsEmpty(res)) {
            self.desserts = res.data.data;
            self.itemsLength = res.data.summary.totalRecordCount;
          }

          self.forceRerender();
        }
        self.loading = false;
      });
    },

    forceRerender() {
      this.renderComponent = false;
      this.$nextTick().then(() => {
        this.renderComponent = true;
      });
    },
  },
};
</script>

<style scoped>
.theme--dark .fullgridtable .theme--light.v-data-table tbody tr:not(:last-child) {
  border-bottom: none;
}

.fullgridtable .v-data-table th {
  border: thin solid #0000001f;
}

.fullgridtable .v-data-table td {
  border: thin solid #0000001f;
}

.fullgridtable.theme--dark .v-data-table th,
.fullgridtable.theme--dark .v-data-table td {
  border: thin solid hsla(0, 0%, 100%, 0.12);
}

.fullgridtable .theme--light.v-data-table tbody tr:not(:last-child) {
  border-bottom: none;
}

.fullgridtable.fullorder .v-data-table th,
.fullgridtable.fullorder .v-data-table td {
  border-bottom: 0 !important;
}

.fullgridtable.fullorder .v-data-table td:not(:last-child),
.fullgridtable.fullorder .v-data-table th:not(:last-child) {
  border-right: 0 !important;
}
</style>
